<template>
  <v-img
    :src="src"
    class="blur"
    :class="{ roundedCorners: rounded, 'align-items-center': vertical }"
    height="100%"
    :max-height="maxHeight"
    border
  >
    <div class="overlay">
      <slot></slot>
    </div>
    <v-img
      :src="src"
      @click="handlePosterClicked"
      class="main-poster"
      :class="{ 'link-active': !!to }"
      :aspect-ratio="aspect"
      :height="vertical ? null : '100%'"
      :width="vertical ? '100%' : null"
      :contain="!aspect"
    ></v-img>
  </v-img>
</template>

<script>
export default {
  name: "blurred-margin-poster",

  props: {
    src: String,
    to: Object,
    aspect: Number,
    maxHeight: Number,
    rounded: Boolean,
    vertical: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handlePosterClicked() {
      if (this.to) {
        this.$router.push(this.to);
      }
    },
  },
};
</script>

<style>
.blur > .v-image__image--cover {
  filter: blur(10px);
  transform: scale(1.1);
}

.blur.roundedCorners {
  border-radius: 4px;
}

.blur .overlay > * {
  pointer-events: auto;
}
</style>

<style scoped>
.blur.align-items-center {
  align-items: center;
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;
  pointer-events: none;
  top: 0;
}

.main-poster {
  z-index: 2;
}

.main-poster.link-active:hover {
  cursor: pointer;
}
</style>
